import { cn } from '@/lib/utils';

export default function SelectionCard({ icon, title, description, selected, onClick, className, testId }) {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testId}
      className={cn(
        'ees-card-hover w-full text-left rounded-lg border p-5 sm:p-6 cursor-pointer bg-white',
        selected
          ? 'border-[#9ec043] ring-1 ring-[#9ec043]/30 bg-[#f8faf2]'
          : 'border-gray-200 hover:border-[#9ec043]/40 hover:bg-gray-50',
        className
      )}
    >
      {icon && <div className="mb-3 text-[#9ec043]">{icon}</div>}
      <h3 className="text-base sm:text-lg font-semibold text-[#32373c] mb-1">{title}</h3>
      {description && <p className="text-sm text-gray-500 leading-relaxed">{description}</p>}
      {selected && (
        <div className="mt-3 flex items-center gap-1.5 text-xs text-[#9ec043] font-medium">
          <div className="w-4 h-4 rounded-full bg-[#9ec043] flex items-center justify-center">
            <svg className="w-2.5 h-2.5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
            </svg>
          </div>
          Ausgewählt
        </div>
      )}
    </button>
  );
}
